import React, { useEffect, useState } from "react";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";
import ModalBody from "components/modal/components/body";
import { Information } from "assets/icons";
import { MESSAGE_REGEX } from "helper/helper";
import UseContext from "hooks/useContext";
import StyledInput from "components/styledInput/StyledInput";

const Remplacement = () => {
    const { data, setData, language } = UseContext();
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.motifForm.${key}`, defaultValue);
    const { toggle } = useModal();
    // Reopening the modal shows the motif already confirmed, as long as it is this one.
    const [infos, setInfos] = useState(() => {
        const savedMotif = data.motif?.type === "3" ? data.motif : {};
        return {
            type: "3",
            name: savedMotif.name ?? "",
            prenom: savedMotif.prenom ?? "",
            poste: savedMotif.poste ?? "",
            message: savedMotif.message ?? "",
        };
    });
    const [message, setMessage] = useState("");
    const [lengthMessage, setLengthMessage] = useState(false);
    const [validMessage, setValidMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorPrenom, setErrorPrenom] = useState(false);
    const [errorPoste, setErrorPoste] = useState(false);

    const verif = infos.message.length;

    useEffect(() => {
        setValidMessage(MESSAGE_REGEX.test(infos.message));
        if (verif <= 8) {
            setErrorMessage(true);
            setLengthMessage(false);
        } else {
            setErrorMessage(false);
            setLengthMessage(true);
        }
    }, [infos.message, verif]);

    const handleChange = (name) => (e) => {
        const value = e.target.value;

        setInfos((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        if (
            infos.message === "" ||
            infos.name === "" ||
            infos.prenom === "" ||
            infos.poste === ""
        ) {
            if (infos.message === "") setErrorMessage(true);
            else setErrorMessage(false);
            if (infos.name === "") setErrorName(true);
            else setErrorName(false);
            if (infos.prenom === "") setErrorPrenom(true);
            else setErrorPrenom(false);
            if (infos.poste === "") setErrorPoste(true);
            else setErrorPoste(false);
        } else {
            setErrorMessage(false);
            setErrorName(false);
            setErrorPrenom(false);
            setErrorPoste(false);
            setData((prevData) => ({ ...prevData, motif: infos }));
            toggle();
        }
    };
    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                closeLabel={language.getValue("missionCreation.modal.close", "Fermer")}
                description={label("reasonDescriptions.replacement", "Pour remplacer un salarié absent ou dont le contrat est suspendu (congés, arrêt maladie, formation…). Indiquez qui est remplacé et pourquoi.")}
            >
                Remplacement d’un salarié absent
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <div className={"grid grid-cols-2 gap-8"}>
                    <div className={"flex flex-col gap-1.5"}>
                        <StyledInput
                            type={"text"}
                            label={label("name", "Nom")}
                            value={infos.name}
                            onChange={handleChange("name")}
                        />
                        {errorName ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("nameRequired", "Veuillez indiquer un nom")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className={"flex flex-col gap-1.5"}>
                        <StyledInput
                            type={"text"}
                            label={label("firstname", "Prénom")}
                            value={infos.prenom}
                            onChange={handleChange("prenom")}
                        />
                        {errorPrenom ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("firstnameRequired", "Veuillez indiquer un prénom")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className={"col-span-2 flex flex-col gap-1.5"}>
                        <StyledInput
                            type={"text"}
                            label={label("replacedPosition", "Poste remplacé")}
                            value={infos.poste}
                            onChange={handleChange("poste")}
                        />
                        {errorPoste ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("positionRequired", "Veuillez indiquer un poste")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                <div className="mt-5 flex flex-col">
                    <StyledInput
                        type={"textarea"}
                        placeholder={label("reasonPlaceholders.replacement", "Ex. : arrêt maladie jusqu'au 15 novembre, congé maternité, congés payés…")}
                        label={label(
                            "absenceDescription",
                            "Décrivez précisément le motif de l'absence de votre salarié."
                        )}
                        value={infos.message}
                        maxLength={250}
                        minLength={10}
                        isLengthInvalid={!!errorMessage}
                        onChange={handleChange("message")}
                    />
                </div>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={"LG"} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
};

export default Remplacement;
